<template>
  <div>
    <h3 class="mb-4">{{ $t("advancedSecurity.mfa") }}</h3>
    <v-card-text>
      <span v-html="$t('advancedSecurity.explain')"></span>
      <span
        v-html="$t('advancedSecurity.proposal')"
        style="margin-top: 20px;"
      ></span>
    </v-card-text>
    <v-card-text>
      <div class="checkbox-text">
        <v-checkbox v-model="mfaEnabled" @change="updateMfa" />

        <div
          style="display: flex; flex-direction: column; justify-content: center;"
        >
          <strong>{{ $t("advancedSecurity.checkbox-title") }}</strong>
          <span>{{ $t("advancedSecurity.checkbox-text") }}</span>
        </div>
      </div>
    </v-card-text>
  </div>
</template>
<style lang="scss">
.checkbox-text {
  display: flex;
  flex-direction: row;
  align-items: center;
}
</style>
<script>
import SecurityService from "~/service/securityService";
export default {
  name: "MyAdvancedSecurity",
  data() {
    return {
      loading: true,
      config: null,
      mfaEnabled: false
    };
  },
  computed: {},
  methods: {
    async fetchMfaEnabled() {
      try {
        this.loading = true;
        SecurityService.getMfaEnabled().then(data => {
          this.loading = false;
          this.mfaEnabled = data.value;
        });
      } catch (err) {
        console.log(err);
        this.loading = false;
      }
    },
    async updateMfa(value) {
      let response = await this.$dialog.confirm({
        title: this.$t("advancedSecurity.mfa"),
        text: value
          ? this.$t("advancedSecurity.mfaEnableMessage")
          : this.$t("advancedSecurity.mfaDisableMessage"),
        persistent: true,
        icon: false
      });
      if (response) {
        SecurityService.updateMfa(value);
      } else {
        this.mfaEnabled = !value;
      }
    }
  },
  async created() {
    await this.fetchMfaEnabled();
  }
};
</script>
